import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import quiz from './modules/quiz'
// 应用vuex插件
Vue.use(Vuex)

// 创建并暴露store
export default new Vuex.Store({
  // 数据,相当于data
  state: {
    huodongData: [],

    title: '',
  },
  //准备getters——用于将state中的数据进行加工
  getters: {
    huodongData: (state) => state.huodongData,

    title: (state) => state.title,
  },
  //准备mutations——用于操作数据（state）
  mutations: {
    SET_huodongData: (state, huodongData) => {
      state.huodongData = huodongData
    },

    SET_title: (state, title) => {
      state.title = title
    },
  },
  //准备actions——用于响应组件中的动作
  actions: {
    GethuodongData({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get('/ims/livemarkuser/getnormaldata', {
            params: {
              huodongId: payload.huodongId,
            },
          })
          .then((res) => {
            const data = res.data.rows
            data.sort((a, b) => {
              return a.id - b.id
            })
            commit('SET_huodongData', data)
            localStorage.setItem('huodongData', JSON.stringify(data))
            resolve(data)
          })
      }).catch((error) => {
        reject(error)
      })
    },
  },
  modules: {
    quiz
  },
})
